import { computed, inject, Injectable, Signal } from '@angular/core';

import { ConfigService } from '../runtime/config/config.service';

const DEFAULT_CAROUSEL_SECONDS = 5;

// Resolved once per display so no layout re-derives channel values on every render.
@Injectable()
export class SlideLayoutConfigService {
  private readonly configuration = inject(ConfigService).configuration;

  public readonly carouselSeconds: Signal<number> =
    computed(() => this.configuration()?.carouselSecondsPerImage ?? DEFAULT_CAROUSEL_SECONDS);

  public readonly closedCaptions: Signal<boolean> = computed(() => this.configuration()?.closedCaptions === true);
}
